export const removeHTMLTags = (text: string): string => {
    const htmlRegexG = /<(?:"[^"]*"['"]*|'[^']*'['"]*|[^'">])+>/g;
    return text.replace(htmlRegexG, "");
};

export function sliceString(str: string, n: number) {
    if (str.length > n) {
        const x = str.slice(0, n - 1);
        return `${x}...`;
    }
    return str;
}
